import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { StyledBox } from './Box.styles';
import { getSxPropTypes } from './SX_PROP_CONFIG';
export var Box = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledBox, _extends({
    ref: forwardedRef
  }, props));
});
Box.displayName = 'Box';
Box.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.shape(Object.assign({}, getSxPropTypes()))
};